// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"EU11_thecomp__8rG3m"};